<template>
  <div>
    <!-- 添加用户表对话框 -->
    <el-dialog
      title="添加用户表"
      :visible.sync="addDialogVisible"
      width="60%"
      append-to-body
      @close="addDialogClosed"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="rules"
        label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="账号" prop="username">
              <el-input v-model="addForm.username" placeholder="请输入账号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input v-model="addForm.password" type="password" placeholder="请输入密码" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名字" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入用户名字" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="addForm.sex" clearable placeholder="请选择性别" style="width: 100%">
                <el-option key="MAN" label="男" value="MAN"></el-option>
                <el-option key="WOMAN" label="女" value="WOMAN"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="addForm.phone" placeholder="请输入电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="address">
              <el-input v-model="addForm.address" placeholder="请输入地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="enumStatus">
              <el-select v-model="addForm.enumStatus" clearable placeholder="请选择状态" style="width: 100%">
                <el-option key="NORMAL" label="正常" value="NORMAL"></el-option>
                <el-option key="DISABLE" label="禁用" value="DISABLE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="用户邮箱" prop="email">
              <el-input v-model="addForm.email" placeholder="请输入用户邮箱" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否是会员" prop="vip">
              <el-select v-model="addForm.vip" clearable placeholder="请选择是否是会员" style="width: 100%">
                <el-option key="YES" label="是" value="YES"></el-option>
                <el-option key="NO" label="否" value="NO"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="选择角色" prop="roleIds">
              <el-select v-model="addForm.roleIds" clearable placeholder="请选择角色" style="width: 100%">
                <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--到期时间-->
          <el-col :span="12">
            <el-form-item label="到期时间" prop="expirationTime ">
              <el-date-picker
                v-model="addForm.expirationTime"
                type="date"
                value-format="timestamp"
                placeholder="选择到期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="用户排序">
              <el-input v-model="addForm.sort" placeholder="请输入用户排序" />
            </el-form-item>
          </el-col>

          <!--头像-->
          <el-col :span="24">
            <el-form-item label="头像">
              <thumbnail @getFiles="getMd5" :autoCropWidth="200" :autoCropHeight="200" :fixedNumber="[1,1]"></thumbnail>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button @click="addUser">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addUser, getByKey } from '@/api/user/user'
import { getData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import { baseURL } from '@/utils/getawayModule'
import { userRules } from '@/js/rules'

export default {
  name: 'addUser',
  components: { Thumbnail },
  data() {
    return {
      addForm: {}, //添加组织表单
      addDialogVisible: false,
      rules: userRules,
      roleList: []
    }
  },
  created() {
    this.getRoleId()
  },
  methods: {
    //获取头像
    getMd5(obj) {
      let url = `${baseURL.userApi}/file/${obj.md5}/download`
      const protocol = window.location.protocol
      const host = window.location.host
      this.addForm.photo = protocol + '//' + host + url
    },

    //获取角色id
    getRoleId() {
      getByKey().then(res => {
        this.roleList = res.data
      })
    },


    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },
    addDialog() {
      this.addDialogVisible = true
    },
    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addUser() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        this.addForm.enumType = 'NORMAL'
        addUser(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false
          }
        })
      })
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input {
  width: 90%;
}
</style>
